<template>
  <div class="formWrap">
    <el-dialog
      title=""
      :visible.sync="formVisible"
      width="60%"
      :before-close="hideDialog">
        <div class="contentWrap">
          <div class="bt">立即体验</div>
          <img src="../assets/images/pt.png" class="leftImg" />
          <div class="formWraper">
            <div class="formTitle">涿溪防窜货申请体验预约</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" label-position="top">
              <el-form-item label="您的名字" prop="name">
                <el-input v-model="ruleForm.name" placeholder="希望我们如何称呼您"></el-input>
              </el-form-item>
              <el-form-item label="手机/电话" prop="phone">
                <el-input v-model="ruleForm.phone" placeholder="顾问将于1-2个工作日内给您致电"></el-input>
              </el-form-item>
              <el-form-item label="企业名称" prop="company">
                <el-input v-model="ruleForm.company" placeholder="请提供完整的工商注册名称，否则可能导致申请失败"></el-input>
              </el-form-item>
            </el-form>
            <div class="footerWrap">
              <Mybutton class="myButton" @clickFn="formSubmit">提交申请</Mybutton>
            </div>
          </div>
        </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSubmit">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import Mybutton from './Mybutton'
const axios = require('axios')
export default {
  name: 'myForm',
  props: {
    formVisible: Boolean
  },
  components: {
    Mybutton
  },
  data () {
    return {
      ruleForm: {
        name: '',
        phone: '',
        company: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    formSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let that = this
          let data = new FormData()
          data.append('name', this.ruleForm.name)
          data.append('phone', this.ruleForm.phone)
          data.append('company', this.ruleForm.company)
          axios.post('/cms/home/apply.json', data)
            .then(function (response) {
              that.hideDialog()
            })
        }
      })
    },
    hideDialog () {
      this.$emit('changeVisible', false)
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style scoped lang="scss">
/**改弹窗样式**/
.formWrap >>> .el-dialog{
  border-radius: 18px;
}
// .formWrap >>> .el-dialog__header {
//   display: none;
// }
.formWrap >>> .el-dialog__body {
  background: url('../assets/images/dialog_bg.png') bottom right no-repeat;
}
.formWrap >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: normal;
  line-height: 20px;
  padding: 0;
  margin-bottom: 14px;
}

.bt {
  position: absolute;
  top:-27px;
  left: 50%;
  transform: translateX(-50%);
  background: url("../assets/images/bt.png") top left no-repeat;
  width: 264px;
  height: 64px;
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 64px;
}
.contentWrap{
  padding-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
}
  .leftImg{
    margin-top: 120px;
  }
.formWraper{
  width: 50%;
  .formTitle{
    font-size: 24px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: normal;
    color: #0A0909;
    margin-top: 37px;
    margin-bottom: 47px;
  }
  .myButton{
    padding: 12px 40px;
    border-radius: 23px;
    height: auto;
    line-height: 22px;
    margin-top: 26px;
    margin-bottom: 6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MyForm.vue